<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-form @submit.prevent.stop="salva">
      <b-form-group id="input-group-1" label="Nome" label-for="input-1">
        <b-form-input
          id="input-1"
          v-model="empresa.nome"
          placeholder="Nome da empresa"
          type="text"
          required
        ></b-form-input>
      </b-form-group>
      <b-form-group id="input-group-2" label="CPF/CNPJ" label-for="input-2">
        <b-form-input
          id="input-2"
          v-model.lazy="empresa.cnpjCpf"
          placeholder="CPF/CNPJ"
          type="text"
          :maxlength="18"
          :state="
            inicialCnpjCpf
              ? null
              : empresa.cnpjCpf.length === 14 || empresa.cnpjCpf.length === 18
              ? true
              : false
          "
          required
          @change="formataCpfCnpj"
        />
      </b-form-group>

      <b-form-group label="Telefone" label-for="input-3">
        <b-form-input
          id="input-3"
          v-model="empresa.telefone"
          placeholder="(11) 99999-9999"
          type="text"
          :maxlength="empresa.telefone.length === 15 ? 15 : 14"
          :state="
            initialNumber
              ? null
              : empresa.telefone.length === 15 || empresa.telefone.length === 14
              ? true
              : false
          "
          @change="formatarTelefone"
        />
      </b-form-group>

      <b-form-group label="E-mail" label-for="input-4">
        <b-form-input
          id="input-4"
          v-model="empresa.email"
          placeholder="contato@empresa.com"
          type="email"
        />
      </b-form-group>

      <b-form-group label="Responsável" label-for="input-5">
        <b-form-input
          id="input-5"
          v-model="empresa.responsavel"
          placeholder="Nome do responsável"
        />
      </b-form-group>

      <b-form-group label="Filiais vinculadas" label-for="input-6">
        <multiselect
          id="input-6"
          v-model="filiaisSelecionadas"
          placeholder="Filiais"
          :options="filiais"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          :hide-selected="true"
          label="nome"
          track-by="_id"
          selected-label="Selecionado"
          deselect-label="Remover"
          select-label="Adicionar"
        ></multiselect>
      </b-form-group>
      <b-button type="submit" variant="primary">Salvar</b-button>
    </b-form>
  </div>
</template>
<script>
import alertMixin from '@/src/mixins/alertMixin'
import Multiselect from 'vue-multiselect'

export default {
  components: {
    Multiselect,
  },
  mixins: [alertMixin],
  props: {
    isUpdating: {
      type: Boolean,
      default: false,
    },
    estoque: {
      type: Object,
      require: true,
      default: () => {},
      insumo: {},
    },
    setLoading: {
      type: Function,
      default: () => {},
    },
    salvar: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      initialNumber: true,
      inicialCnpjCpf: true,
      filiais: [],
      filiaisSelecionadas: [],
      empresa: {
        nome: '',
        cnpjCpf: '',
        telefone: '',
        email: '',
        responsavel: '',
        filiais: [],
      },
    }
  },
  async created() {
    await Promise.all([this.listaFiliais()])
  },
  methods: {
    async salva() {
      this.empresa.filiais = this.filiaisSelecionadas.map(
        (filial) => filial._id
      )
      await this.salvar(this.empresa)
    },
    async listaFiliais() {
      this.setLoading(true)
      try {
        this.filiais = this.$store.state.auth.currentUser.user.filiais
      } catch (error) {
        console.log(error)
        this.errorMessage(error.error.message)
      } finally {
        this.setLoading(false)
      }
    },
    formatarTelefone() {
      this.initialNumber = false
      this.empresa.telefone = this.empresa.telefone.replace(/[^0-9]/g, '')

      if (this.empresa.telefone.length === 11) {
        if (this.empresa.telefone[2] === '9') {
          this.empresa.telefone = this.empresa.telefone.replace(
            /(\d{2})(\d{5})(\d{4})/,
            '($1) $2-$3'
          )
        } else {
          this.empresa.telefone = ''
        }
      } else if (this.empresa.telefone.length === 10) {
        this.empresa.telefone = this.empresa.telefone.replace(
          /(\d{2})(\d{4})(\d{4})/,
          '($1) $2-$3'
        )
      } else {
        this.empresa.telefone = ''

        this.errorMessage('Telefone inválido')
      }
    },
    formataCpfCnpj() {
      console.log(this.empresa.cnpjCpf)
      this.inicialCnpjCpf = false

      this.empresa.cnpjCpf = this.empresa.cnpjCpf.replace(/[^0-9]/g, '')

      if (this.empresa.cnpjCpf.length === 11) {
        this.empresa.cnpjCpf = this.empresa.cnpjCpf.replace(
          /(\d{3})(\d{3})(\d{3})(\d{2})/,
          '$1.$2.$3-$4'
        )
      } else if (this.empresa.cnpjCpf.length === 14) {
        this.empresa.cnpjCpf = this.empresa.cnpjCpf.replace(
          /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
          '$1.$2.$3/$4-$5'
        )
      } else {
        this.empresa.cnpjCpf = ''
        this.errorMessage('CPF/CNPJ inválido')
      }
    },
  },
}
</script>
<style scoped>
.input-color {
  background-color: rgba(78, 78, 199, 0.212);
}
</style>
